import { render, staticRenderFns } from "./AppliedPrepaymentDetails.vue?vue&type=template&id=505947ab&scoped=true"
import script from "./AppliedPrepaymentDetails.vue?vue&type=script&lang=js"
export * from "./AppliedPrepaymentDetails.vue?vue&type=script&lang=js"
import style0 from "./AppliedPrepaymentDetails.vue?vue&type=style&index=0&id=505947ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505947ab",
  null
  
)

export default component.exports